import React from 'react';
import { stripHTML } from '../../utils/helpers';
import { Info } from 'lucide-react';

interface WelcomeMessageProps {
  message: string;
}

export const WelcomeMessage: React.FC<WelcomeMessageProps> = ({ message }) => {
  if (!message || !stripHTML(message).trim()) return null;

  return (
    <div className="flex relative mb-6 shadow-sm rounded-lg bg-white border border-gray-100 items-stretch overflow-hidden">
      <div className="w-1 flex-shrink-0 bg-teamcare-cyan" />
      <div className="flex-shrink-0 flex items-center px-3">
        <Info size={20} color="#4FCEBB" />
      </div>
      <div className="flex items-start">
        <div className='py-3 pr-3'>
          <div
            className="text-sm text-gray-700 leading-relaxed trix-content"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
      </div>
    </div>
  );
};
